import { FaImage, FaTimes } from 'react-icons/fa';
import { useToast } from '../../Toast/ToastContext';
import { useT } from '../../../hooks/useT';
import styles from '../PropertyPanel.module.css';

function ImageField({ label, value, onChange, editMode }) {
  const isAdmin = editMode === 'admin';
  const { showToast } = useToast();
  const t = useT();

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (isAdmin) {
      // Admin: persist to public/images/ folder
      const imagePath = `/images/${file.name}`;
      showToast({
        message: `${t('editor.imageInstructions', 'Add the file to public/images/, then reload to see it.')} (${file.name})`,
      });
      onChange(imagePath);
    } else {
      // Visitor: temporary blob URL for this session
      const url = URL.createObjectURL(file);
      onChange(url);
    }
  };

  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      {value ? (
        <div className={styles.imagePreview}>
          <img src={value} alt="" className={styles.imageThumb} />
          <button className={styles.imageRemove} onClick={() => onChange(null)}>
            <FaTimes />
          </button>
        </div>
      ) : (
        <label className={styles.imageUpload}>
          <FaImage />
          <span>Upload Image</span>
          <input type="file" accept="image/*" onChange={handleUpload} hidden />
        </label>
      )}
    </div>
  );
}

export default ImageField;
